import { render } from "./AnswerListPage.vue?vue&type=template&id=2ffda0dc&ts=true"
import script from "./AnswerListPage.vue?vue&type=script&lang=ts"
export * from "./AnswerListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__